/*
 * Copyright (c) 2020 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2020 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	Help.js
 *
 * Description:	Generic Greenlight Help code.
 */

(function () {

    "use strict";

    /**
     * Initialises the help.
     * @param {string} SupportKey - The support key of the current session.
     * @param {string} Version - The version of the software.
     */
	function Help(SupportKey, Version) {

		// The support key of the current session.
		this.g_szSupportKey = SupportKey;

		// The current version.
		this.g_szVersion = Version;

		// If the help menu is in animation.
		this.g_bHelpAnimating = false;
	};

	/**
	 * Toggles the help menu.
	 */
	Help.prototype.toggleHelpMenu = function () {

		// If we are not already animating the help menu.
		if (!g_oHelp.g_bHelpAnimating) {

			// Set that the menu is currently animating.
			g_oHelp.g_bHelpAnimating = true;

			// If the help menu is currently shown.
			if ($("#divHelp").css("display") == "none") {

				// Ensure the menu is just off screen.
				$("#divHelp").css("right", 1 - + $("#divHelp").width());

				// Show the menu.
				$("#divHelp").show();

				// Slide the menu in from the right.
				$("#divHelp").animate({
					right: 7
				}, 'swing', function () {

					// Set that we are no longer animating.
					g_oHelp.g_bHelpAnimating = false;
				});
			}
			// If the help menu is currently not shown.
			else {

				// Slide the menu out to the right.
				$("#divHelp").animate({
					right: 1 - + $("#divHelp").width()
				}, 'swing', function () {

					// Hide the menu once the animation has finished.
						$("#divHelp").hide();

					// Set that we are no longer animating.
					g_oHelp.g_bHelpAnimating = false;
				});
			}
		}
	};

	/**
	 * Updates the help menu.
	 */
	Help.prototype.updateHelpMenu = function () {

		// Update the session id.
		g_oHelp.updateHelpMenu_SupportKey();

		// Update the version number.
		g_oHelp.updateHelpMenu_VersionNumber();
	};

	/**
	 * Updates the help menu support key.
	 */
	Help.prototype.updateHelpMenu_SupportKey = function () {

		// Upate the support key.
		$("#tdHelpSupportKey").html(g_oHelp.g_szSupportKey != null && g_oHelp.g_szSupportKey.length > 0 ? g_oHelp.g_szSupportKey : "Unknown");
	};

	/**
	 * Updates the help menu version number.
	 */
	Help.prototype.updateHelpMenu_VersionNumber = function () {

		// Upate the version number.
		$("#tdHelpVersion").html(g_oHelp.g_szVersion != null && g_oHelp.g_szVersion.length > 0 ? g_oHelp.g_szVersion : "Unknown");
	};

	/*
	 * Help Auto Closing.
	 */
	$(document).on('click', function (event) {

		// If we are not already animating the help menu, the help menu is curreny open, and we want to close the menu.
		if (!g_oHelp.g_bHelpAnimating && $("#divHelp").css("display") != "none") {

			// If the click is outside of help menu.
			if ($(event.target).parents("#divHelp").length == 0 && event.target.id != "divHelp") {

				// Close the menu.
				g_oHelp.toggleHelpMenu();
			}
		}
	});

	// Add the viewer object to the window.
	window.Help = Help;
}());